
import { Component, Vue, Watch } from 'vue-property-decorator'
import { categoryDto } from '@/api/goods'

@Component
export default class customizeKeyboard extends Vue {
  visible = false
  titleList = [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.', '取消' ]
  sideList = [ '删除', '清空', '确认']
  price = ''
  packageIndex = 0

  @Watch('visible')
  onVisibleChange (val: boolean) {
    if (val) {
      document.querySelector('.van-pull-refresh__track').classList.add('set-transform')
    } else {
      document.querySelector('.van-pull-refresh__track').classList.remove('set-transform')
    }
  }

  show (price: string, packageIndex: number) {
    this.price = price
    this.packageIndex = packageIndex
    this.visible = true
  }

  keyboardClick (text: string) {
    if (text === '取消') {
      this.visible = false
    } else if (text === '删除') {
      if (this.price.length > 0) {
        this.price = this.price.substr(0, this.price.length - 1)
      } else {
        this.price = ''
      }
    } else if (text === '清空') {
      this.price = ''
    } else if (text === '确认') {
      if (Number(this.price) === 0) {
        return this.$toast('价格不能为空或0！')
      }
      this.$emit('confirm', this.price, this.packageIndex)
      this.visible = false
    } else {
      // 第一个字符串不能是.
      if (text === '.' && this.price.length === 0) return
      // 字符串中只能有一个.
      if (text === '.' && this.price.includes('.')) return
      // 小数点后最多2位
      if (this.price.includes('.')) {
        const arr = this.price.split('.')
        if (arr[1].length === 2) return
      }
      this.price = this.price + text
    }
  }

  toPrice () {
    this.visible = false
    this.$emit('push', this.packageIndex)
  }

  handleCancel () {
    this.visible = false
  }

  handleSure () {
    this.visible = false
  }
}
